import { WarehouseIcon } from "@phosphor-icons/react/Warehouse";

// Marks the saved location used by default for pickup or delivery.
export function LocationsDefaultMarker() {
  return (
    <WarehouseIcon
      className="ml-2 inline-block h-3.5 w-3.5 text-content-muted"
      weight="fill"
    />
  );
}
